// frontend/src/components/Planet.js
import React from 'react';

export default function Planet({ image }) {
    return (
        <div style={{
            position: 'absolute',
            bottom: '-100px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            height: '300px',
            background: `url(${image}) no-repeat center bottom`,
            backgroundSize: 'contain',
            zIndex: 1
        }} />
    );
}
